// @ts-nocheck
import * as TYPES from '../types';

const initialState = {
    visibleFilterComponents: [],
    selectedCategoriesFilters: [],
    list: [],
};

const playerSearch = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case TYPES.PLAYER_SEARCH_FILTERS_LIST_CHANGED: {
            return {
                ...state,
                selectedCategoriesFilters: payload,
            };
        }
        case TYPES.PLAYER_SEARCH_VISIBLE_FILTERS_LIST_CHANGED: {
            return {
                ...state,
                visibleFilterComponents: payload,
            };
        }
        case TYPES.PLAYER_SEARCH_VISIBLE_FILTERS_DELETED: {
            return {
                ...state,
                visibleFilterComponents: payload,
            };
        }
        case TYPES.PLAYER_SEARCH_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        case TYPES.PLAYER_SEARCH_ALL_DATA_CLEARED: {
            return {
                ...state,

                list: initialState.list,
            };
        }

        default:
            return state;
    }
};

export default playerSearch;
